import { render } from "./CustomerService.vue?vue&type=template&id=bdef67a6&scoped=true"
import script from "./CustomerService.vue?vue&type=script&lang=js"
export * from "./CustomerService.vue?vue&type=script&lang=js"

import "./CustomerService.vue?vue&type=style&index=0&id=bdef67a6&lang=scss&scoped=true"

import exportComponent from "/Users/marc.bush/Sites/ensotyres/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdef67a6"]])

export default __exports__